import React from 'react';

import ReportingHubForm from '../components/ReportingHub/ReportingHubForm';
import mapReportTemplateToForm from '../util/mapReportTemplateToForm';
import { newReportTemplate } from '../validationSchemas/ReportTemplateSchema';

function ReportingHubNewPage() {
  const reportTemplate = mapReportTemplateToForm(newReportTemplate);
  return <ReportingHubForm reportTemplate={reportTemplate} />;
}

export default ReportingHubNewPage;
